import {
  listPin, listPinFocus, mapPin, mapPinFocus, markUnSelect, getIcon, MarkSelectSize,
} from '../img/pin';
// import { iconHeart, iconHeartFocus } from '../img/heart';
// import { setNewFavorite, setDelFavorite } from './common-offline';
// import alertLogin from './alert-login';
import map from './map';
import center from './center';
import { getInfoOfDeviceOS } from '../../../../assets/js/common-es6';
import pagination from "./pagination";

const offlineCenterSearchListBtn = document.getElementsByClassName('offline-center__search-list-field')[0];
const offlineCenterListBoxBtn = document.getElementsByClassName('offline-center-list-box');
const offlineCenterList = document.getElementById('offlineCenterList');
let deviceOS = getInfoOfDeviceOS();

if ((deviceOS === 'web') && (location.href.indexOf('/offline/mobile') !== -1)) {
  // TODO:: 원인을 알 수 없으나 아이폰 6s 기종을 pc로 인식해서 문제 발생.
  deviceOS = 'ios';
}
// const clientID = getClientID();
let openedIdx = -1;
let pinnedIdx = -1;
let animatedIdx = -1;

const releasePin = (markers) => {
  const isPinned = pinnedIdx !== -1;

  const pinCode = isPinned ? document.querySelectorAll('.list__item--code')[pinnedIdx + 1] : null;
  const marker = isPinned ? markers[pinnedIdx] : null;
  const myPin = isPinned ? listPin[pinnedIdx] : null;
  const myIconPin = isPinned ? mapPin[pinnedIdx] : null;

  if (pinCode && marker && myPin) {
    pinCode.src = myPin;
    marker.setIcon(myIconPin);
  }

  pinnedIdx = -1;
};

const releaseAni = (markers) => {
  const isAnimated = animatedIdx !== -1;

  const marker = isAnimated ? markers[animatedIdx] : null;

  if (marker) {
    marker.setAnimation(null);
  }

  animatedIdx = -1;
};

const releaseInfo = (infoWindows) => {
  const isOpened = openedIdx !== -1;

  const infoWindow = isOpened ? infoWindows[openedIdx] : null;

  if (infoWindow) {
    infoWindows[openedIdx].close();
  }

  openedIdx = -1;
};

let timeOut;

const getClickHandler = (marker, infoWindow, pinCode, mainHeart, boundCenter, idx, markers = null) => {
  const clicking = () => {
    // FIXME 정보창 때문에 맵이동이 안일어날 때는 stopOnce 주지 않기
    map.setStopOnce(true);

    // FIXME clearTimeout 동작안해서 마음대로 stopOnce가 꺼져버림
    if (timeOut) {
      clearTimeout(timeOut);
      timeOut = undefined;
    }

    timeOut = setTimeout(() => {
      map.setStopOnce(false);
    }, 300);

    setTimeout(() => {
      marker.setAnimation(null);
      animatedIdx = -1;
    }, 700);
    animatedIdx = idx;

    // 마크 아이콘 업데이트
    const markIcon = markers[idx].icon.url || markers[idx].icon;
    let selectPinMark = '';
    let markSize = '';

    if (markIcon.indexOf('unselected') !== -1) {
      marker.setZIndex(99);
      selectPinMark = markIcon.replace(/unselected/g, 'selected');
      markSize = MarkSelectSize;

      for (const _marker of markers) {
        if (_marker.icon.url.indexOf('unselected') === -1) {
          marker.setZIndex(9);
          const iconUrl = _marker.icon.url.replace(/selected/g, 'unselected');
          _marker.setIcon(getIcon(iconUrl));
          _marker.setTitle(boundCenter.id);
        }
      }
    } else {
      marker.setZIndex(9);
      selectPinMark = markIcon.replace(/selected/g, 'unselected');
      markSize = (deviceOS === 'web') ? new N.Size(30, 30) : new N.Size(20, 20);
    }

    marker.setIcon(getIcon(selectPinMark, markSize));
    marker.setTitle(boundCenter.id);
    pinnedIdx = idx;
    openedIdx = idx;

    // 모바일 검색결과 UI 및 리스트 스크롤 대응
    if (offlineCenterSearchListBtn && offlineCenterSearchListBtn.classList.contains('is-normal')) {
      offlineCenterSearchListBtn.click();
    }

    for (let i = 0; i < offlineCenterListBoxBtn.length; i += 1) {
      const centerIcon = offlineCenterListBoxBtn[i].getElementsByClassName('offline-center-box__icon')[0];

      if ((boundCenter) && (boundCenter.id === centerIcon.getAttribute('id') * 1)) {
        centerIcon.style.height = '29px';
        centerIcon.style.backgroundImage = centerIcon.style.backgroundImage.replace(/unselected/g, 'selected');

        if (centerIcon.style.backgroundImage.indexOf(selectPinMark) !== -1) {
          if (deviceOS !== 'web') {
            offlineCenterList.scrollTop = centerIcon.parentElement.offsetTop - 48;
          } else {
            offlineCenterList.scrollTop = centerIcon.parentElement.offsetTop;
          }
        }
      } else if (centerIcon.style.backgroundImage.indexOf('_selected') !== -1) {
        centerIcon.style.height = '20px';
        centerIcon.style.backgroundImage = centerIcon.style.backgroundImage.replace(/_selected/g, '_unselected');
      }
    }

    // 마크 아이콘 업데이트
    if (deviceOS === 'web') {
      if (markIcon.indexOf('_unselected') !== -1) {
        pagination.openDetailPopup(boundCenter);
      }
    }

    if (markIcon.indexOf('_selected') !== -1) {
      pagination.closeDetailPopup(boundCenter);
    }
  };

  return clicking;
};

const getZoomHandler = (infoWindows) => {
  const zomming = () => {
    // 줌 동작시 열려있는 정보창 닫기
    const infoWindow = openedIdx !== -1 ? infoWindows[openedIdx] : null;

    if (infoWindow && infoWindow.getMap()) {
      infoWindow.close();
      openedIdx = -1;
    }
  };

  return zomming;
};

const setMarkerEvent = (markers, infoWindows) => {
  const boundCenters = center.getBoundCenter();

  for (let i = 0, ii = markers.length; i < ii; i += 1) {
    const marker = markers[i];
    const infoWindow = infoWindows[i];
    const boundCenter = boundCenters[i];

    N.Event.addListener(marker, 'click', () => {
      getClickHandler(marker, infoWindow, null, null, boundCenter, i, markers)();
    });
  }

  N.Event.addListener(map, 'zoom_changed', getZoomHandler(infoWindows));
};

export default setMarkerEvent;
